// extracted by mini-css-extract-plugin
export var headerCell = "_5m-1";
export var loadingStateCell = "_5m-4";
export var rowWrapper = "_5m-3";
export var standaloneTable = "_5m-5";
export var table = "_5m-0";
export var white = "_5m-2";